import { Paper } from 'shared/ui/paper'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const RoomsListSkeleton = () => {
  return (
    <Paper
      padding={[12, 0, 16, 0]}
      className={s.container}
    >
      <div className={s.header}>
        <Skeleton
          width={140}
          height={20}
        />

        <div className={s.filter}>
          <Skeleton
            width={60}
            height={16}
          />
        </div>
      </div>

      <div className={s.list}>
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className={s.card}
          >
            <Skeleton
              width={'100%'}
              height={50}
            />

            <div className={s.content}>
              <Skeleton
                width={120}
                height={20}
              />

              <Skeleton
                width={90}
                height={16}
              />

              <Skeleton
                width={90}
                height={10}
              />

              <Skeleton
                className={s.button}
                width={'100%'}
                height={32}
                borderRadius={10}
              />
            </div>
          </div>
        ))}
      </div>
    </Paper>
  )
}
